import { differenceInWeeks } from "date-fns";
import { useMemo } from "react";

import type { CategoryType } from "@/components/game-categories";
import { datetimeToJS, formatDateDisplay } from "@/helpers/parsers";

import { GameStatusEnum } from "../types";

interface GameStatusType {
  closingAt?: string;
  openingAt?: string;
  primaryCategory?: CategoryType;
  status: keyof typeof GameStatusEnum;
}

export default function useGameStatus(game: GameStatusType) {
  return useMemo(() => {
    let isOpen = true;
    let nameSuffix = "";

    if (game.status === GameStatusEnum.CS) {
      nameSuffix = game.openingAt
        ? ` - Opening ${formatDateDisplay(game.openingAt, false)} 🚀`
        : " - COMING SOON 🚀";
    } else if (
      game.status === GameStatusEnum.PC ||
      game.status === GameStatusEnum.TC
    ) {
      isOpen = false;
      nameSuffix = " - CLOSED";
    } else if (game.closingAt) {
      const date = datetimeToJS(game.closingAt);

      if (differenceInWeeks(date, new Date()) < 2) {
        nameSuffix = ` - Closing ${formatDateDisplay(game.closingAt, false)}`;
      }
    }

    return { isOpen, nameSuffix };
  }, [game]);
}
